import Dashboard from "../../components/Dashboard";
import FrontDeskWorkOrders from "../../components/FrontDeskWorkOrders";
import FrontDeskRooms from "../../components/FrontDeskRooms";
import CallList from "../../components/CallList";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BuildIcon from "@mui/icons-material/Build";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import PhoneIcon from "@mui/icons-material/Phone";

export const frontDeskConfig = [
  {
    path: "/",
    component: Dashboard,
    label: "Dashboard",
    icon: DashboardIcon,
    showInNav: true,
  },
  // {
  //   path: "/orders",
  //   component: PurchaseOrdersPage,
  //   label: "Orders",
  //   icon: ReceiptIcon,
  //   showInNav: true,
  // },
  {
    path: "/workOrders",
    component: FrontDeskWorkOrders,
    label: "Work Orders",
    icon: BuildIcon,
    showInNav: true,
  },
  {
    path: "/rooms",
    component: FrontDeskRooms,
    label: "Rooms",
    icon: MeetingRoomIcon,
    showInNav: true,
  },
  {
    path: "/callList",
    component: CallList,
    label: "Call List",
    icon: PhoneIcon,
    showInNav: true,
  },
];

export const frontDeskMetadata = {
  roleName: "Front Desk",
  defaultRoute: "/",
};
